function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("defs", null, React.createElement("rect", {
  id: "SVGID_1_",
  width: 325.7,
  height: 132.8
})), React.createElement("clipPath", {
  id: "SVGID_2_"
}, React.createElement("use", {
  xlinkHref: "#SVGID_1_",
  overflow: "visible"
})), React.createElement("path", {
  clipPath: "url(#SVGID_2_)",
  fill: "#D5002B",
  d: "M115.4,118.7l-32-99.3C78.9,4.2,71.2,0,59.5,0H0c4.7,1.9,7.8,14,7.8,14 l28.7,99.7c3.3,12.5,13.7,19.1,25.4,19.1h63C120.3,132,115.4,118.7,115.4,118.7"
}), React.createElement("path", {
  clipPath: "url(#SVGID_2_)",
  fill: "#D5002B",
  d: "M210.3,118.7l32-99.3C246.8,4.2,254.5,0,266.2,0h59.5c-4.7,1.9-7.8,14-7.8,14 l-28.7,99.7c-3.3,12.5-13.7,19.1-25.4,19.1h-63C205.4,132,210.3,118.7,210.3,118.7"
}), React.createElement("rect", {
  x: 128,
  y: 0.8,
  clipPath: "url(#SVGID_2_)",
  fill: "#D5002B",
  width: 70,
  height: 132
}));

var SvgWestpac = function SvgWestpac(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "325.7px",
    height: "132.8px",
    viewBox: "0 0 325.7 132.8",
    enableBackground: "new 0 0 325.7 132.8",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWestpac, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/westpac.dd4a872f.svg";
export { ForwardRef as ReactComponent };